export default __webpack_public_path__ + "static/media/jeep.4eca68a8.svg";